import * as constants from './actions';

const initialState = {
    showFindYouRepPopup: false,
    localRepData: {},
    hiddenRepresentatives: [],
    representativesVisibility: false
};

export default function poll(state = initialState, { type, payload }) {
    switch (type) {
        case constants.ON_FIND_YOUR_REP_POPUP:
            return {
                ...state,
                showFindYouRepPopup: payload
            };
        case constants.ON_FIND_YOUR_REP_ERROR:
            return {
                ...state,
                isFindError: payload
            };
        case constants.SET_LOCAL_REPRESENTATIVE:
            return {
                ...state,
                localRepData: payload,
                hiddenRepresentatives: []
            };
        case constants.LOCAL_REP_GO_TO_FIND_SCREEN:
            return {
                ...state,
                nextActionIdentifier: payload
            };
        case constants.IS_LOCAL_REP_LOADING:
            return {
                ...state,
                isLocalRepLoading: payload
            };
        case constants.ON_HIDE_REPRESENTATIVE:
            const hiddenRepresentatives = state.hiddenRepresentatives.concat(payload);
            return {
                ...state,
                hiddenRepresentatives: hiddenRepresentatives
            };
        case constants.ON_SHOW_REPRESENTATIVE:
            const visibleRepresentatives =
                state.hiddenRepresentatives.filter(e => e !== payload) || [];
            return {
                ...state,
                hiddenRepresentatives: visibleRepresentatives,
                representativesVisibility: false
            };
        case constants.ON_SHOW_LIST_WITH_REPS:
            return {
                ...state,
                representativesVisibility: !state.representativesVisibility
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/LocalRep/reducer.js